import { Button, Select, Space, Typography } from 'antd'
import { useState } from 'react'
import localStorage from 'utils/localStorage'

import Styles from './index.module.scss'

interface OptionType {
	value: string
	label: string
}
const options: OptionType[] = [
	{
		value: 'DASH_CX',
		label: 'DashCX',
	},
	{
		value: 'TURBO_CX',
		label: 'TurboCX',
	},
]
const env = process.env.REACT_APP_EDGE_MODE
const PlatformSelector = () => {
	const [platform, setPlatform] = useState(
		localStorage.get('platform') || 'DASH_CX'
	)

	const handleClick = () => {
		localStorage.set('platform', platform)

		window.location.href = '/login'
	}

	const handleChange = (value: string) => {
		setPlatform(value)
	}
	return (
		<Space className={Styles.layoutComponent}>
			<Typography.Text>Deployment mode - {env?.toLowerCase()}</Typography.Text>
			<div className={Styles.layoutComponent_Content}>
				<Select
					value={platform}
					style={{ width: 120 }}
					options={options}
					onChange={handleChange}
				/>
				<Button onClick={handleClick}>Continue</Button>
			</div>
		</Space>
	)
}

export default PlatformSelector
